const getSlug = require('speakingurl');

exports.transliterate = (string, options) => {
	return getSlug(string, options);
};
